@if (component$ | async; as component) {
  <div class="carousel-wrapper" [style]="'background-color :'+ component.background">
    <div class="container">
      <div class="info-component">
        <div>
          @switch (component.titleTag) {
            @case ('H1') {
              <h1 class="h2-component">{{component.title}}</h1>
            }
            @case ('H2') {
              <h2 class="h2-component">{{component.title}}</h2>
            }
            @default {
              <div class="h2-component">{{component.title}}</div>
            }
          }
          @if (component.description) {
            <p class="h2-description">{{component?.description}}</p>
          }
        </div>
        @if (component.image) {
          <cx-media [container]="component?.image" format="product"></cx-media>
        }
      </div>
      @if ((isMobile() | async)) {
        <cx-carousel
          [items]="items$ | async"
          [template]="carouselItem"
          [itemWidth]="(component?.scroll === 'ONE') ? '100%' :  '50%'"
          [hideIndicators]="true"
          [hideButtons]="false"
          [animation]="animation"
          >
        </cx-carousel>
      } @else {
        <cx-carousel
          [items]="items$ | async"
          [template]="carouselItem"
          [itemWidth]="(component?.scroll === 'ONE') ? '100%' : '300px'"
          [hideIndicators]="true"
          [hideButtons]="false"
          [animation]="animation"
          >
        </cx-carousel>
      }
    </div>
  </div>
}


<ng-template #carouselItem let-item="item">
  @if (item) {
    <app-custom-product-item [item]="item" [pdp]="false"></app-custom-product-item>
  }
</ng-template>
